export class LandingPageContent {
  constructor(data) {
    if (!data?.hero?.title || !Array.isArray(data?.features) || !Array.isArray(data?.audiences)) {
      throw new Error('LandingPageContent invalid');
    }
    this.hero = data.hero;
    this.features = data.features;
    this.audiences = data.audiences;
    this.footer = data.footer;
  }
}

export const createLandingPageContent = (data) => new LandingPageContent(data);

